'use client';

import React, { createContext, useContext } from 'react';
import { getContainer } from '@framework/di/getContainer';
import DataroomAccessRepository from '../infrastructure/DataroomAccessRepository';
import DataroomErrorHandler from '@dataroom/error-handler';

const useDataroomAccess = () => {
  const container = getContainer();
  const dataroomRepository = container.get<DataroomAccessRepository>(DataroomAccessRepository);

  const checkDataroomAccess = async (dataroomId: number) => {
    try {
      await dataroomRepository.checkDataroomAccess({ dataroomId });
      return true;
    } catch (error) {
      container.get(DataroomErrorHandler).handleError(error);
      return false;
    }
  };

  return {
    checkDataroomAccess,
  };
};

export type DataroomAccessContextType = ReturnType<typeof useDataroomAccess>;

export const DataroomAccessContext = createContext<DataroomAccessContextType | null>(null);

export const useDataroomAccessContext = () => {
  const context = useContext(DataroomAccessContext);
  if (!context) {
    throw new Error('useDataroomAccessContext must be used within a DataroomAccessContextProvider');
  }
  return context;
};

interface IProps {
  children: React.ReactNode,
}

const DataroomAccessContextProvider = ({ children }: IProps) => {
  const contextValue = useDataroomAccess();

  return (
    <DataroomAccessContext.Provider value={ contextValue }>
      { children }
    </DataroomAccessContext.Provider>
  );
};

export default DataroomAccessContextProvider;
